(function () {
  // Store autoplay intervals and state for cleanup
  const autoplayState = new WeakMap();
  const initializedSections = new WeakSet();

  const setImageClasses = (section, activeId) => {
    const images = section.querySelectorAll(".how-to-use-tabs__image");

    images.forEach((image) => {
      image.classList.remove("how-to-use-tabs__image--active");
    });

    const activeImage = section.querySelector(
      `[data-how-to-use-tabs="${activeId}"].how-to-use-tabs__image`
    );

    if (activeImage) {
      activeImage.classList.add("how-to-use-tabs__image--active");
    }
  };

  const setActiveBlock = (section, index) => {
    const blocks = section.querySelectorAll(".how-to-use-tabs__block");
    if (!blocks[index]) return;

    const activeBlock = blocks[index];
    const activeId = activeBlock.dataset.howToUseTabs;

    blocks.forEach((block) => {
      block.classList.remove("how-to-use-tabs__block--active");
      block.classList.remove("active");
    });

    activeBlock.classList.add("how-to-use-tabs__block--active");
    activeBlock.classList.add("active");
    setImageClasses(section, activeId);
  };

  const initClassesDesktop = (section) => {
    setActiveBlock(section, 0);
  };

  const initClassesMobile = (section) => {
    const images = section.querySelectorAll(".how-to-use-tabs__image");
    const tabsWrapper = section.querySelector(
      ".how-to-use-tabs__content-blocks-wrapper"
    );
    const tabs = section.querySelectorAll(".how-to-use-tabs__block");

    tabsWrapper?.classList.add("swiper-wrapper");
    images.forEach((image) => {
      image.classList.remove("how-to-use-tabs__image--active");
      image.classList.add("swiper-slide");
    });
    tabs.forEach((tab) => {
      tab.classList.remove("how-to-use-tabs__block--active");
      tab.classList.remove("active");
      tab.classList.add("swiper-slide");
    });
  };

  // Clear any existing autoplay interval
  const clearAutoplay = (section) => {
    const state = autoplayState.get(section);
    if (state?.intervalId) {
      clearInterval(state.intervalId);
      state.intervalId = null;
    }
  };

  // Start autoplay interval
  const startAutoplayInterval = (section) => {
    const state = autoplayState.get(section);
    if (!state || !state.enabled) return;

    // Clear any existing interval first
    if (state.intervalId) {
      clearInterval(state.intervalId);
    }

    state.intervalId = setInterval(() => {
      const blocks = section.querySelectorAll(".how-to-use-tabs__block");
      state.currentIndex = (state.currentIndex + 1) % blocks.length;
      setActiveBlock(section, state.currentIndex);
    }, state.delay);
  };

  // Initialize autoplay state and start
  const initAutoplayDesktop = (section) => {
    const container = section.querySelector(".how-to-use-tabs");
    const autoplayEnabled = container?.dataset.autoplay === "true";
    const autoplayDelay = parseFloat(container?.dataset.autoplayDelay || 3) * 1000;

    const blocks = section.querySelectorAll(".how-to-use-tabs__block");
    if (blocks.length <= 1) {
      autoplayState.set(section, { enabled: false });
      return;
    }

    // Initialize state
    autoplayState.set(section, {
      enabled: autoplayEnabled,
      delay: autoplayDelay,
      currentIndex: 0,
      intervalId: null,
      isPaused: false
    });

    if (autoplayEnabled) {
      startAutoplayInterval(section);
    }
  };

  const blockToggleDesktop = (section) => {
    const blocks = section.querySelectorAll(".how-to-use-tabs__block");
    const container = section.querySelector(".how-to-use-tabs");
    const autoplayEnabled = container?.dataset.autoplay === "true";

    blocks.forEach((block, index) => {
      // Click handler - same for both autoplay on/off
      block.addEventListener("click", () => {
        const state = autoplayState.get(section);
        if (state) {
          state.currentIndex = index;
        }
        setActiveBlock(section, index);
      });

      // Hover handlers
      if (autoplayEnabled) {
        // When autoplay is ON: hover shows the item, pauses autoplay, 
        // and on leave continues from next item after the hovered one
        block.addEventListener("mouseenter", () => {
          const state = autoplayState.get(section);
          if (state && !state.isPaused) {
            state.isPaused = true;
            clearAutoplay(section);
          }
          // Show the hovered item
          setActiveBlock(section, index);
          // Update currentIndex so when we leave, it continues from here
          if (state) {
            state.currentIndex = index;
          }
        });

        block.addEventListener("mouseleave", () => {
          const state = autoplayState.get(section);
          if (state && state.isPaused && state.enabled) {
            state.isPaused = false;
            // Start autoplay - it will go to next item after delay
            startAutoplayInterval(section);
          }
        });
      } else {
        // When autoplay is OFF: original hover behavior
        block.addEventListener("mouseenter", () => {
          setActiveBlock(section, index);
        });
      }
    });

    // Also handle hover on media area when autoplay is enabled
    if (autoplayEnabled) {
      const mediaArea = section.querySelector(".how-to-use-tabs__media");

      if (mediaArea) {
        mediaArea.addEventListener("mouseenter", () => {
          const state = autoplayState.get(section);
          if (state && !state.isPaused) {
            state.isPaused = true;
            clearAutoplay(section);
          }
        });

        mediaArea.addEventListener("mouseleave", () => {
          const state = autoplayState.get(section);
          if (state && state.isPaused && state.enabled) {
            state.isPaused = false;
            startAutoplayInterval(section);
          }
        });
      }
    }
  };

  const initSliderMobile = (section) => {
    const sliderTabs = section.querySelector(".swiper--content-tabs");
    const sliderImage = section.querySelector(".swiper--how-to-use-tabs");
    const container = section.querySelector(".how-to-use-tabs");

    // Get autoplay settings
    const autoplayEnabled = container?.dataset.autoplay === "true";
    const autoplayDelay = parseFloat(container?.dataset.autoplayDelay || 3) * 1000;

    if (sliderTabs && sliderImage) {
      const pagination = sliderTabs.querySelector(
        ".how-to-use-tabs__pagination > .swiper-pagination"
      );

      if (sliderTabs.swiper) sliderTabs.swiper.destroy();
      if (sliderImage.swiper) sliderImage.swiper.destroy();

      // Configure autoplay for mobile Swiper
      const autoplayConfig = autoplayEnabled
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false;

      const swiperTabs = new Swiper(sliderTabs, {
        enabled: true,
        loop: autoplayEnabled,
        speed: 800,
        spaceBetween: 8,
        slidesPerView: 1.1,
        centeredSlides: true,
        autoplay: autoplayConfig,
        breakpoints: {
          990: {
            enabled: false,
            slidesPerView: 1,
          },
        },
        pagination: pagination
          ? {
            el: pagination,
            type: "bullets",
            clickable: true,
          }
          : false,
      });

      const swiperImage = new Swiper(sliderImage, {
        loop: autoplayEnabled,
        speed: 800,
        spaceBetween: 8,
        slidesPerView: 1.1,
        centeredSlides: true,
        breakpoints: {
          990: {
            enabled: false,
            slidesPerView: 1,
          },
        },
      });

      swiperTabs.controller.control = swiperImage;
      swiperImage.controller.control = swiperTabs;
    }
  };

  const destroySlider = (section) => {
    const images = section.querySelectorAll(".how-to-use-tabs__image");
    const tabs = section.querySelectorAll(".how-to-use-tabs__block");
    const sliderTabs = section.querySelector(".swiper--content-tabs");
    const sliderImage = section.querySelector(".swiper--how-to-use-tabs");

    if (sliderTabs?.swiper) sliderTabs.swiper.destroy();
    if (sliderImage?.swiper) sliderImage.swiper.destroy();

    images.forEach((image) => {
      image.removeAttribute("style");
      image.classList.remove("swiper-slide");
    });
    tabs.forEach((tab) => {
      tab.removeAttribute("style");
      tab.classList.remove("swiper-slide");
    });
  };

  const initSection = (section) => {
    if (section && section.classList.contains("how-to-use-tabs-section")) {
      let currentMode = null; // Track current mode: 'desktop' or 'mobile'

      const sectionResizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          const isDesktop = entry.contentRect.width >= 990;
          const newMode = isDesktop ? "desktop" : "mobile";

          // Only re-initialize if mode changed
          if (newMode === currentMode) return;
          currentMode = newMode;

          // Clear any existing autoplay
          clearAutoplay(entry.target);

          if (isDesktop) {
            destroySlider(entry.target);
            initClassesDesktop(entry.target);

            // Only add event listeners once
            if (!initializedSections.has(entry.target)) {
              initializedSections.add(entry.target);
              blockToggleDesktop(entry.target);
            }

            initAutoplayDesktop(entry.target);
          } else {
            initClassesMobile(entry.target);
            initSliderMobile(entry.target);
          }
        });
      });

      sectionResizeObserver.observe(section);
    }
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    // Reset initialization state for reloaded sections
    initializedSections.delete(event.target);
    autoplayState.delete(event.target);
    initSection(event.target);
  });
})();